import type { DEVICE_PERMISSION } from 'YM/declare';

import type { EVoxRoles } from 'providers/declare';

import { isFalsyValue } from '../helpers/isFalsyValue';

/** Данные, отправляемые на любое событие метрики */
export interface CommonMetricsParams {
    meeting_role?: EVoxRoles;
    setting_permission_camera?: DEVICE_PERMISSION;
    setting_permission_mic?: DEVICE_PERMISSION;
}

/** Отформатированные данные для отправки в метрику */
interface FormattedCommonMetricsParams {
    meeting_role: EVoxRoles;
    setting_permission_camera: DEVICE_PERMISSION;
    setting_permission_mic: DEVICE_PERMISSION;
}

/** Ключи данных отправляемых в метрику */
const keys: (keyof CommonMetricsParams)[] = ['meeting_role', 'setting_permission_camera', 'setting_permission_mic'];

/** Форматирование данных перед отправкой */
export default function formatCommonParams(params: CommonMetricsParams): FormattedCommonMetricsParams {
    return keys.reduce((acc, currKey) => {
        const value = params[currKey];

        if (!isFalsyValue(value, true)) {
            return { ...acc, [currKey]: value };
        }

        return acc;
    }, {} as FormattedCommonMetricsParams);
}
